import { useNavigate } from "react-router-dom";
import { Button, Card, Empty, Icon, Space, Tag, Text } from "@app/ui";
import { useT, useFormatDateTime } from "../i18n.js";
import { useOrgs } from "../orgs/OrgContext.js";

/**
 * The tenants this account can work in. The profile is the one place a user can
 * see every membership at once — the header switcher only shows the active one —
 * so it doubles as the switcher of last resort.
 */

export function OrganizationsTab() {
  const t = useT();
  const fmtDate = useFormatDateTime();
  const { orgs, org, selectOrg } = useOrgs();
  const navigate = useNavigate();

  return (
    <Card title={t("profile.orgs")}>
      <Space direction="vertical" size="md" className="w-full">
        <Text small secondary>
          {t("profile.orgsHint")}
        </Text>

        {orgs.length === 0 ? (
          <Empty description={t("profile.orgsEmpty")} />
        ) : (
          <div className="pf-orgs">
            {orgs.map((o) => {
              const active = o.id === org?.id;
              return (
                <div key={o.id} className={`pf-org${active ? " is-active" : ""}`}>
                  <span className="pf-device__icon">
                    <Icon name="building" size={18} />
                  </span>
                  <div className="pf-org__body">
                    <span className="pf-org__name">{o.name}</span>
                    <span className="pf-org__meta">
                      {`${t(`role.${o.memberRole}`)} · ${t("common.createdAt")} ${fmtDate(o.createdAt)}`}
                    </span>
                  </div>
                  {active ? (
                    <Tag color="primary">{t("profile.orgActive")}</Tag>
                  ) : (
                    <Button
                      size="sm"
                      variant="subtle"
                      onClick={() => {
                        selectOrg(o.id);
                        navigate("/dashboard");
                      }}
                    >
                      {t("profile.orgSwitch")}
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Space>
    </Card>
  );
}
